<template>
  <section>
    <div class="mod-block">
      <h3 class="title">商品供应商协议</h3>
      <el-form ref="form" :model="form" label-width="80px" size="mini" class="mod-form" :rules="rules">
        <el-form-item label="" prop="supplier" class="label-text">
          <span slot="label">二级供应商编码</span>
          <el-input v-model="form.supplier" disabled></el-input>
        </el-form-item>
        <el-form-item label="" prop="supName" class="label-text">
          <span slot="label">二级供应商名称</span>
          <el-input v-model="form.supName" disabled></el-input>
        </el-form-item>
        <el-form-item label="" prop="primarySuppInd" class="label-text">
          <span slot="label">是否主供应商</span>
          <el-select v-model="form.primarySuppInd" disabled>
            <el-option value="Y" label="是">是</el-option>
            <el-option value="N" label="否">否</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="storeReturnInd" class="label-text">
          <span slot="label">是否允许退货</span>
          <el-select v-model="form.storeReturnInd">
            <el-option value="Y" label="是">是</el-option>
            <el-option value="N" label="否">否</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="货源国" prop="originalCountry">
          <el-input v-model="form.originalCountry" disabled></el-input>
        </el-form-item>
        <el-form-item label="是否主国家" prop="primaryCountryInd">
          <el-select v-model="form.primaryCountryInd" disabled>
            <el-option value="Y" label="是">是</el-option>
            <el-option value="N" label="否">否</el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="innerPackSize">
          <span slot="label">内包装数
            <el-tooltip content="内包装数量" placement="top" class="tooltipBtn">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </span>
          <el-input-number v-model="form.innerPackSize" :controls="false" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item prop="suppPackSize">
          <span slot="label">货箱数
            <el-tooltip content="货箱数量" placement="top" class="tooltipBtn">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </span>
          <el-input-number v-model="form.suppPackSize" :controls="false" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="" prop="baseCost" class="label-text">
          <span slot="label">单位不含税成本（元）</span>
          <el-input-number v-model="form.baseCost" :controls="false" :min="0" :precision="4"></el-input-number>
        </el-form-item>
        <el-form-item prop="ti">
          <span slot="label">层
            <el-tooltip content="货仓库位商品单层摆放数量" placement="top" class="tooltipBtn">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </span>
          <el-input v-model="form.ti"></el-input>
        </el-form-item>
        <el-form-item prop="hi">
          <span slot="label">层高
            <el-tooltip content="货仓库位商品摆放层数" placement="top" class="tooltipBtn">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </span>
          <el-input v-model="form.hi"></el-input>
        </el-form-item>
        <el-form-item label="单个长(cm)" prop="dimLength">
          <el-input v-model="form.dimLength"></el-input>
        </el-form-item>
        <el-form-item label="单个宽(cm)" prop="dimWidth">
          <el-input v-model="form.dimWidth" ></el-input>
        </el-form-item>
        <el-form-item label="单个高(cm)" prop="dimHeight">
          <el-input v-model="form.dimHeight"></el-input>
        </el-form-item>
        <el-form-item label="净重(g)" prop="dimWeight">
          <el-input v-model="form.dimWeight"></el-input>
        </el-form-item>
        <el-form-item label="皮重(g)" prop="weight">
          <el-input v-model="form.weight"></el-input>
        </el-form-item>
        <el-form-item label="舍入级别" prop="roundLvl">
          <el-input v-model="form.roundLvl" disabled></el-input>
        </el-form-item>
        <el-form-item label="舍入比例" prop="roundRate">
          <el-input v-model="form.roundRate" disabled></el-input>
        </el-form-item>
        <el-form-item label="最小订货量" prop="minOrderQty">
          <el-input v-model="form.minOrderQty"></el-input>
        </el-form-item>
      </el-form>
    </div>
  </section>
</template>
<script>
  export default {
    inject: ['getMod', 'getComData'],
    data () {
      return {
        form: {
          storeReturnInd: '',
          supplier: '',
          supName: '',
          primarySuppInd: 'Y',
          originalCountry: 'CN',
          primaryCountryInd: 'Y',
          innerPackSize: undefined,
          suppPackSize: undefined,
          baseCost: undefined,
          ti: '',
          hi: '',
          dimLength: '',
          dimWidth: '',
          dimHeight: '',
          dimWeight: '',
          weight: '',
          roundLvl: 'C',
          roundRate: '30',
          minOrderQty: ''
        },
        rules: {}
      }
    },
    methods: {
      getRules () {
        let ar = ['supplier', 'supName', 'primarySuppInd', 'storeReturnInd', 'originalCountry', 'primaryCountryInd', 'baseCost', 'ti', 'hi', 'dimLength', 'dimWidth', 'dimHeight', 'dimWeight', 'weight', 'roundLvl', 'roundRate']
        let map = {}
        ar.forEach(item => {
          map[item] = [
            {validator: this.$validate.required, trigger: 'blur'},
            {required: true, trigger: 'blur', message: '输入不能为空'}
          ]
        })
        map['innerPackSize'] = [{required: true, validator: this.$validate.positiveInteger, trigger: 'blur'}, {validator: this.$validate.required, trigger: 'blur'}]
        map['suppPackSize'] = [{ required: true, validator: this.validatorSuppPackSize, trigger: 'blur' }]
        return map
      },
      validatorSuppPackSize (rule, value, callback) {
        let suppPackSize = Number(value)/Number(this.form.innerPackSize);
        if (value === '' || Math.floor(suppPackSize) !== suppPackSize) {
          callback(new Error('货箱数必须是内包装数倍数'));
        }else {
          callback();
        }
      }
    },
    mounted () {
      // 编辑
      let {editData, userInfo} = this.getComData()
      if (editData.suppModel) {
        Object.assign(this.form, editData.suppModel)
      } else {
        this.form.supplier = userInfo.id
        this.form.supName = userInfo.name
      }
      // 异步验证
      this.rules = this.getRules()
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    }
  }
</script>
<style lang="scss" scoped>
  .mod-block {
    background-color: #fff;
    border-radius: 5px;
    padding: 12px 10px 10px;
    overflow: hidden;
    margin-bottom: 10px;
    .title {
      display: flex;
      align-items: center;
      font-size: 14px;
      padding-bottom: 10px;
      &::before {
        display: inline-block;
        content: "";
        height: 1em;
        border: 1px solid #3366ff;
        margin-right: 2px;
      }
    }
  }
  .mod-form {
    .el-form-item {
      float: left;
      width: 190px;
      margin-bottom: 12px!important;
      border: 1px solid #ddd;
      padding: 3px;
      border-radius: 3px;
      margin-right: 10px;
    }
    /deep/ .label-text .el-form-item__label {
      line-height: 14px;
    }
    /deep/ .el-form-item__label {
      text-align: center;
      padding: 0 0 0 0;
    }
    /deep/ .el-input__inner {
      width: 100px;
    }
    /deep/ .el-form-item__content {
      font-size: 12px;
    }
    .mod-tag {
      background: #8400FF;
      color: #fff;
      border-radius: 4px;
      font-size: 12px;
      font-style: normal;
      padding: 2px;
    }
    .btns {
      float: left;
      padding-top: 4px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/newProductApplication/newpool/add/standard/commodity-supplier-agreement.vue